export enum DocumentItemAmountsSource {
	Net = "Net",
	Gross = "Gross",
	Manual = "Manual"
}
